module.exports = __webpack_public_path__ + "img/model-1.5d89626.webp";